module.exports = __webpack_public_path__ + "img/l200_seat.94291cfa.jpg";